import React from 'react';
import { getImageUrl, handleImageError } from '../utils/api';

// One line of an order: thumbnail, name/variant/unit price, line total.
// Styles live in globals.css (.order-item) so they can respond to screen width.
const OrderItem = ({ item }) => (
  <div className="order-item">
    <div className="order-item-thumb">
      <img src={getImageUrl(item.image)} onError={handleImageError} alt={item.name} loading="lazy" />
    </div>
    <div className="order-item-info">
      <div className="order-item-name">{item.name}</div>
      {item.variantLabel && <div className="order-item-meta">{item.variantLabel}</div>}
      <div className="order-item-meta">₹{item.price} × {item.quantity}</div>
    </div>
    <div className="order-item-total">₹{item.price * item.quantity}</div>
  </div>
);

export default OrderItem;
